import pluralize from 'pluralize';
import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import TimesheetDetails from './TimesheetDetails';

export default function BulkUnsubmit({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Unsubmit"
      variant="delete"
      confirmText="Unsubmit"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .timesheets()
          .bulkUnsubmit(ids)
          .then((r) => r.data)
      }
      renderRow={TimesheetDetails}>
      {`Are you sure you want to unsubmit ${ids.length} ${pluralize('timesheet', ids.length)}?`}
    </BulkActionModal>
  );
}
